<h1 mat-dialog-title>{{ 'INSERT_BID' | translate }}</h1>

<mat-dialog-content>
  <div *ngIf="hasInstallmentsInvoice"
       class="orange-50"
       style="padding: 10px 12px; border-radius: 4px; margin-bottom: 12px;"
       fxLayout="row"
       fxLayoutAlign="start center"
       fxLayoutGap="8px">
    <mat-icon class="orange-700-fg">warning</mat-icon>
    <span class="orange-700-fg">{{ 'INSTALLMENTS_ALERT' | translate }}</span>
  </div>

  <form
    [formGroup]="auctionBidFormGroup"
    fxLayout="column"
    fxLayoutGap="20px"
    class="line-height-1.75"
  >
    <div fxLayout="row" fxLayoutGap="10px">
      <div fxLayout="column" fxFlex="50">
        <span
        ><b>{{ 'INVOICE_AMOUNT' | translate }}:</b>
          {{ auction.invoiceAmount | currency: 'EUR' }}</span
        >
        <span
        ><b>{{ 'DOWN_PAYMENT_AMOUNT' | translate }}:</b>
          {{ accontoLordo | currency: 'EUR' }}</span
        >
        <span
        ><b>{{ 'INVOICE_DUE_DATE' | translate }}:</b>
          {{ auction.invoiceDueDate | dateFormat }}</span
        >
        <span
        ><b>{{ 'INVOICE_EXPECTED_PAYMENT_DATE' | translate }}:</b>
          {{ auction.invoiceExpectedPaymentDate | dateFormat }}</span
        >
      </div>

      <div fxLayout="column" fxFlex="50">
        <mat-form-field fxFlex appearance="outline">
          <mat-label>{{ 'BID_INTEREST_RATE' | translate }} %</mat-label>
          <input
            matInput
            type="number"
            formControlName="bidInterestRate"
            required
            [step]="step"
            [appPercentageDirective]
            (valueChanged)="bidInterestRateTemp = $event"
          />
          <mat-error>
            <span *ngIf="auctionBidFormGroup.get('bidInterestRate').hasError('required')">{{
                    'ERROR.REQUIRED' | translate
              }}</span>
            <span *ngIf="auctionBidFormGroup.get('bidInterestRate').hasError('max')">{{
                    'ERROR.HIGH' | translate
              }}</span>
          </mat-error>
        </mat-form-field>

        <ng-container *ngIf="auction.invoiceIasCompliant">
          <span style="margin-top: -16px;">*{{ 'IAS_COMPLIANT_INVOICE' | translate }}</span>
        </ng-container>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="10px">
      <div fxLayout="row" fxFlex="50" fxLayoutAlign="start center" fxLayoutGap="10px">
        <span><b>{{ 'FUND' | translate }}:</b></span>
        <button mat-button
                style="border-radius: 20px;
                    display: inline-block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;"
                [matMenuTriggerFor]="walletMenu">
          <mat-icon style="font-weight: 700; margin-right: 4px">account_balance_wallet</mat-icon>
          <span [matTooltip]="selectedFund?.name">{{ selectedFund?.name }}</span>
        </button>
        <mat-menu #walletMenu>
          <button *ngFor="let fund of buyer?.funds" mat-menu-item (click)="selectFund(fund)">
            <span>{{ fund.name }}</span>
          </button>
        </mat-menu>
      </div>
      <div fxLayout="column" fxFlex="50" fxLayoutGap="4px">
        <ng-container *ngIf="virtualBalance">
          <span><b>{{ 'VIRTUAL_BALANCE' | translate }}:</b> {{ virtualBalance.virtualBalance | currency: 'EUR' }}</span>
          <span class="text-secondary">
            {{ 'COMMITTED_DOWNPAYMENTS' | translate }}:
            {{ (virtualBalance.committedDownpayments ?? 0) | currency: 'EUR' }}
          </span>
        </ng-container>
        <ng-container *ngIf="wallet && !virtualBalance">
          <b>{{ 'WALLET_BALANCE' | translate }}:</b> {{ wallet.balance | currency: 'EUR' }}
        </ng-container>
      </div>
    </div>

    <mat-card *ngIf="hasInsufficientLiquidity" class="mt-16 p-16 mat-elevation-z0 warning-card">
      <mat-card-content>
        <mat-icon class="s-24 mr-8 warning-icon">warning</mat-icon>
        <span>{{ 'ALERT_INSUFFICIENT_LIQUIDITY' | translate }}</span>
      </mat-card-content>
    </mat-card>

    <mat-divider *ngIf="showPassword"></mat-divider>

    <ng-container *ngIf="showPassword">
      <div fxLayout="row">
        <mat-form-field fxFlex>
          <mat-label>{{ 'TRANSACTION_PASSWORD' | translate }}</mat-label>
          <input
            matInput
            type="password"
            id="passBid"
            formControlName="transactionPassword"
            required />
          <mat-error>
            <span *ngIf="auctionBidFormGroup.get('transactionPassword').hasError('forbidden')">{{
                    'ERROR.WRONG_TRANSACTION_PASSWORD' | translate
              }}</span>
            <span *ngIf="auctionBidFormGroup.get('transactionPassword').hasError('required')">{{
                    'ERROR.REQUIRED' | translate
              }}</span>
          </mat-error>
        </mat-form-field>
      </div>
    </ng-container>

    <mat-divider></mat-divider>

    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
      <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
        <mat-checkbox formControlName="tos_1"></mat-checkbox>
        <div style="padding-top: 3px;">
          <span
            style="cursor: pointer"
            (click)="
              auctionBidFormGroup.get('tos_1').setValue(!auctionBidFormGroup.get('tos_1').value)
            ">
            {{ 'TOS_1' | translate }}
          </span>
          <a href="assets/pdf/b_conditions.pdf" target="_blank">{{ 'TOS_1_LINK' | translate }}</a>.
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
        <mat-checkbox formControlName="tos_2"></mat-checkbox>
        <div style="padding-top: 3px;">
          <span
            style="cursor: pointer"
            (click)="auctionBidFormGroup.get('tos_2').setValue(!auctionBidFormGroup.get('tos_2').value)">
            {{ 'TOS_2' | translate }}
          </span>
          <a style="cursor: pointer" (click)="downloadConditions()">{{ 'TOS_2_LINK' | translate }}</a>.
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
        <mat-checkbox formControlName="tos_3"></mat-checkbox>
        <div style="padding-top: 3px;">
          <span
            style="cursor: pointer"
            (click)="auctionBidFormGroup.get('tos_3').setValue(!auctionBidFormGroup.get('tos_3').value)">
            {{ 'TOS_3' | translate }}
          </span>
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
        <mat-checkbox formControlName="tos_4"></mat-checkbox>
        <div style="padding-top: 3px;">
          <span
            style="cursor: pointer"
            (click)="auctionBidFormGroup.get('tos_4').setValue(!auctionBidFormGroup.get('tos_4').value)">
            {{ 'TOS_4' | translate }}
          </span>
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>
  </form>

  <div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="start center">
      <button mat-icon-button (click)="showInvoice = !showInvoice">
        <ng-container *ngIf="showInvoice; else down">
          <mat-icon>keyboard_arrow_up</mat-icon>
        </ng-container>
        <ng-template #down>
          <mat-icon>keyboard_arrow_down</mat-icon>
        </ng-template>
      </button>
      <h3 style="cursor: pointer" (click)="showInvoice = !showInvoice">
        {{ 'INVOICE_DETAIL' | translate }}
      </h3>
    </div>
    <div [@addressExpand]="showInvoice ? 'expanded' : 'collapsed'" style="overflow: hidden;">
      <div fxLayout="row" fxLayoutAlign="space-between start" class="line-height-1.75">
        <div fxLayout="column" fxFlex="70" fxFlexOffset="26px">
          <span><b>{{ 'SELLER_BUSINESS_NAME' | translate }}:</b> {{ auction.sellerBusinessName }}</span>
          <span><b>{{ 'DEBTOR_BUSINESS_NAME' | translate }}:</b> {{ auction.debtorBusinessName }}</span>
          <span><b>{{ 'INVOICE_AMOUNT' | translate }}:</b>{{ auction.invoiceAmount | currency: 'EUR' }}</span>
          <span><b>{{ 'DOWN_PAYMENT_AMOUNT' | translate }}:</b> {{ accontoLordo | currency: 'EUR' }}</span>
          <span><b>{{ 'DEBTOR_RATING' | translate }}:</b> {{ auction.debtorRating }}</span>
          <span><b>{{ 'INVOICE_DUE_DATE' | translate }}:</b>{{ auction.invoiceDueDate | dateFormat }}</span>
          <span><b>{{ 'INVOICE_EXPECTED_PAYMENT_DATE' | translate }}
            :</b>{{ auction.invoiceExpectedPaymentDate | dateFormat }}</span>
        </div>

        <div fxLayout="column" fxFlex fxLayoutGap="10px" fxFlexOffset="26px" style="padding: 8px">
          <button mat-stroked-button (click)="downloadInvoice()">
            {{ 'VIEW_INVOICE' | translate }}
          </button>
          <button mat-stroked-button (click)="downloadRating(UserType.debtor)">
            {{ 'VIEW_RATING' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">
    <span>{{ 'CANCEL' | translate }}</span>
  </button>

  <button mat-button color="accent" [disabled]="auctionBidFormGroup.invalid" (click)="submitBid()">
    <span>{{ 'SEND' | translate }}</span>
  </button>
</mat-dialog-actions>
